export function searchForm() {
    const form = $('.main .search-form');
    const input = form.find('input[type="text"]');
    const resetBtn = `<button type="reset" class="reset-button">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 11L1 1M11 1L1 11" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                       </button>`;

    if (input.val() && form.find('.reset-button').length === 0) {
        form.find('.input-wrapper').append(resetBtn);
    }


    input.on('input', function () {
        if (input.val() && form.find('.reset-button').length === 0) {
            form.find('.input-wrapper').append(resetBtn);
        }
        if (input.val() === '') {
            form.find('.reset-button').remove();
        }
    });

    form.on('click', '.reset-button', function (e) {
        if (e.target.closest('.reset-button')) {
            input.val('');
            form.find('.reset-button').remove();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/searchForm.js